import { getCode } from '@/api';
import { getNoticesHot, getRewardPunishesHot, getDynamicsHot, getRisksHot, getSpecialsHot, getResearchesHot, getPoliciesHot, getTypicalHot, getIndustriesHot } from '@/api';
import empty from '@/components/empty';

export const page = {

    components: {
        empty
    },
    data() {
        return {
            tabList: [],
            tabId: undefined,

            list: [],
            total: 0,
            pageSize: 10
        };
    },
    created() {
        const { query } = this.$route;
        const { tab } = query || {};
        if (tab) {
            this.$set(this, 'tabId', tab);
        }

    },
    mounted() {
        this.getNewsList();
        this.getHotList();
    },
    methods: {
        tabHandle(row) {
            const { id, fullName } = row;
            if (this.tabId !== id) {
                this.$emit('layoutInit', {
                    menus: fullName
                })
                this.$set(this, 'tabId', id);
                this.getNewsList(1)
            }
        },
        handleCurrentChange(e) {
            this.getNewsList(e)
        },

        getCode(code) {
            let tabList = getCode({ code });
            return tabList;
        },

        async getTabList(code) {
            console.log("在外面")
            if (this.tabList.length === 0) {
                const tabList = await this.getCode(code);
                this.$set(this, 'tabList', tabList);
                this.$set(this, 'tabId', tabList[0].id)
            }
        },

        pageHandle(data) {
            const { total, current, records, size, } = data;
            this.$set(this, 'total', total || 0);
            this.$set(this, 'pageSize', size || 10);
            this.$set(this, 'list', records || []);
        },

        //右侧推荐
        getHotList() {
            this.hotRequestMethod().then(res => {
                this.$emit('layoutInit', {
                    recommend: res,
                    nav: {
                        c_name: this.routeTitle
                    }
                });
            })
        }
    },
    computed: {
        routeTitle({ $route }) {
            const { meta: { title } } = $route;
            return title;
        },
        hotRequestMethod() {
            const { meta: { title } } = this.$route;
            // 1信用动态，2行业信用，3诚信宣传，4政策法规，5信用研究，6专项治理,7风险提示,8联合奖惩,9通知公告
            switch (title) {
                case '信用动态':
                    return getDynamicsHot;
                case '行业信用':
                    return getIndustriesHot;
                case '诚信宣传':
                    return getTypicalHot;
                case '政策法规':
                    return getPoliciesHot;
                case '信用研究':
                    return getResearchesHot;
                case '专项治理':
                    return getSpecialsHot;
                case '风险提示':
                    return getRisksHot;
                case '联合奖惩':
                    return getRewardPunishesHot;
                case '通知公告':
                    return getNoticesHot;
                default:
                    break;
            }
        }
    },
    filters: {
        sliceBrief(brief) {
            if (brief && brief.length > 145) {
                return brief.slice(0, 145) + '...';
            } else {
                return brief;
            }
        }
    }
}